export default __webpack_public_path__ + "static/ausmasa-3dc628fc8a7118c7f92498d275f0694c.png";